"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var NavbarMain = /** @class */ (function (_super) {
    __extends(NavbarMain, _super);
    function NavbarMain() {
        var _this = _super.call(this, constants_1.DATA_HEADER_BOTTOM) || this;
        if (!_this.getElement())
            return _this;
        _this.navToggle = _this.getChildElement("[".concat(constants_1.DATA_NAV_TOGGLE, "]"));
        _this.navbarMainWrap = _this.getChildElement("[".concat(constants_1.DATA_NAVBAR_MAIN_WRAP, "]"));
        _this.subNavTrigger = _this.getChildElements("[".concat(constants_1.DATA_SUBMENU_TRIGGER, "]"));
        _this.subNavBacklink = _this.getChildElements("[".concat(constants_1.DATA_SUBMENU_BACKLINK, "]"));
        _this.submenu = _this.getChildElements("[".concat(constants_1.DATA_SUBMENU, "]"));
        _this.bodyTag = document.getElementsByTagName('body')[0];
        _this.navbarMeta = _this.getChildElement("[".concat(constants_1.DATA_NAVBAR_META, "]"));
        _this.navbarSocial = _this.getChildElement("[".concat(constants_1.DATA_NAVBAR_SOCIAL, "]"));
        _this.navItemDropdown = _this.getChildElement("[".concat(constants_1.DATA_NAV_ITEM_DROPDOWN, "]"));
        _this.navItemInitial = _this.getChildElements("[".concat(constants_1.DATA_NAV_ITEM_INITIAL, "]"));
        // Mobile
        _this.toggleMainNavMobile();
        _this.toggleSubNavMobile();
        _this.backlinkLogic();
        // Desktop
        _this.dropdownNav();
        // Reset nav on resize
        window.addEventListener('resize', function () {
            var mql = window.matchMedia('(min-width: 992px)');
            if (mql.matches == true) {
                _this.resetNav();
            }
        });
        return _this;
    }
    NavbarMain.prototype.toggleMainNavMobile = function () {
        var _this = this;
        var _a;
        (_a = this.navToggle) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (e) {
            var _a, _b, _c;
            e.preventDefault();
            (_a = _this.navToggle) === null || _a === void 0 ? void 0 : _a.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
            _this.bodyTag.classList.toggle(constantsClasses_1.CLASS_NAV_OPEN);
            (_b = _this.navbarMainWrap) === null || _b === void 0 ? void 0 : _b.classList.toggle(constantsClasses_1.CLASS_DNONE);
            // Scroll to top of submenu
            (_c = _this.navbarMainWrap) === null || _c === void 0 ? void 0 : _c.scrollTo(0, 0);
        });
    };
    NavbarMain.prototype.toggleSubNavMobile = function () {
        var _this = this;
        var _a;
        (_a = this.subNavTrigger) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            element.addEventListener('click', function (e) {
                var _a;
                e.preventDefault();
                element.nextElementSibling.classList.remove(constantsClasses_1.CLASS_DNONE);
                _this.navbarMeta.classList.add(constantsClasses_1.CLASS_DNONE);
                _this.navbarSocial.classList.add(constantsClasses_1.CLASS_DNONE);
                // Scroll to top of submenu
                (_a = _this.navbarMainWrap) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            });
        });
    };
    NavbarMain.prototype.backlinkLogic = function () {
        var _this = this;
        var _a;
        (_a = this.subNavBacklink) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                element.parentElement.classList.add(constantsClasses_1.CLASS_DNONE);
                _this.navbarMeta.classList.remove(constantsClasses_1.CLASS_DNONE);
                _this.navbarSocial.classList.remove(constantsClasses_1.CLASS_DNONE);
            });
        });
    };
    NavbarMain.prototype.dropdownNav = function () {
        var _a, _b;
        if (!this.navItemDropdown) {
            (_a = this.navItemInitial) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                element.classList.remove(constantsClasses_1.CLASS_DNONE);
            });
        }
        else {
            (_b = this.navItemInitial) === null || _b === void 0 ? void 0 : _b.forEach(function (element) {
                element.classList.add(constantsClasses_1.CLASS_DNONE);
            });
        }
    };
    NavbarMain.prototype.resetNav = function () {
        var _a, _b, _c;
        if (this.bodyTag.classList.contains(constantsClasses_1.CLASS_NAV_OPEN)) {
            this.bodyTag.classList.remove(constantsClasses_1.CLASS_NAV_OPEN);
        }
        if (this.navToggle.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
            this.navToggle.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        }
        if (!this.navbarMainWrap.classList.contains(constantsClasses_1.CLASS_DNONE)) {
            this.navbarMainWrap.classList.add(constantsClasses_1.CLASS_DNONE);
        }
        (_a = this.submenu) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            if (!element.classList.contains(constantsClasses_1.CLASS_DNONE)) {
                element.classList.add(constantsClasses_1.CLASS_DNONE);
            }
        });
        if ((_b = this.navbarMeta) === null || _b === void 0 ? void 0 : _b.classList.contains(constantsClasses_1.CLASS_DNONE)) {
            this.navbarMeta.classList.remove(constantsClasses_1.CLASS_DNONE);
        }
        if ((_c = this.navbarSocial) === null || _c === void 0 ? void 0 : _c.classList.contains(constantsClasses_1.CLASS_DNONE)) {
            this.navbarSocial.classList.remove(constantsClasses_1.CLASS_DNONE);
        }
    };
    return NavbarMain;
}(AbstractComponent_1.default));
exports.default = NavbarMain;
